import { Link } from 'react-router-dom';
import styled from 'styled-components';

export default styled<typeof Link>(Link)`
  color: inherit;
`;
